enum BranchFormSteps {
    info = 0,
    regions = 1,
    review = 2,
}

export default BranchFormSteps;
